import {memo, useCallback, useMemo} from "react";
import {AlertOperatorDropdownProps} from "./alertOperatorDropdown.typings";
import {Condition_SecurityAlertCondition_Operator} from "../../../proto/generated/nexus";
import {MenuItem, Select, SelectChangeEvent} from "@mui/material";

export const operatorDisplayNames: Record<Condition_SecurityAlertCondition_Operator, string> = {
    [Condition_SecurityAlertCondition_Operator.CROSSING]: "Crossing",
    [Condition_SecurityAlertCondition_Operator.CROSSING_UP]: "Crossing Up",
    [Condition_SecurityAlertCondition_Operator.CROSSING_DOWN]: "Crossing Down",
    [Condition_SecurityAlertCondition_Operator.EQUAL_TO]: "Equal To",
    [Condition_SecurityAlertCondition_Operator.GREATER_THAN]: "Greater Than",
    [Condition_SecurityAlertCondition_Operator.LESS_THAN]: "Less Than",
    [Condition_SecurityAlertCondition_Operator.OPERATOR_UNKNOWN]: "",
    [Condition_SecurityAlertCondition_Operator.UNRECOGNIZED]: "",
}

const availableOperators: Condition_SecurityAlertCondition_Operator[] = [
    Condition_SecurityAlertCondition_Operator.CROSSING,
    Condition_SecurityAlertCondition_Operator.CROSSING_UP,
    Condition_SecurityAlertCondition_Operator.CROSSING_DOWN,
    Condition_SecurityAlertCondition_Operator.EQUAL_TO,
    Condition_SecurityAlertCondition_Operator.GREATER_THAN,
    Condition_SecurityAlertCondition_Operator.LESS_THAN
]

const AlertOperatorDropdown: React.FC<AlertOperatorDropdownProps> = ({onOperatorChange, value, className}) => {

    const menuItems = useMemo(() => {
        return availableOperators.map(v => ({label: operatorDisplayNames[v], value: v}));
    }, [])

    const onSelect = useCallback((event: SelectChangeEvent<Condition_SecurityAlertCondition_Operator>) => {
        onOperatorChange(event.target.value as Condition_SecurityAlertCondition_Operator)
    }, [onOperatorChange])

    return <Select fullWidth size="small" value={value} onChange={onSelect} className={className}>
        {menuItems.map(m => <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>)}
    </Select>
}

export default memo(AlertOperatorDropdown);